import { useRef } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { BottomSheet } from '@/components/atoms/bottomsheet';
import { StyledContent } from './styles';
import type { SheetRef } from 'react-modal-sheet';
import { Text } from '@/components/atoms/text';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';
import { SearchMunicipalityForm } from '../form';
import { MunicipalityAutocomplete } from '@/components/atoms/inputs/municipalityInput';
import type { MunicipalityWithSearch } from '@/graphql/types/municipality';

interface SearchModalProps {
  open: boolean;
  variant?: 'advanced' | 'municipality';
  onClose: () => void;
  onMunicipalityChange?: (municipality: MunicipalityWithSearch | null) => void;
}

export const SearchMunicipalityBottomSheet = ({
  open,
  variant,
  onClose,
  onMunicipalityChange,
}: SearchModalProps) => {
  const bottomSheetRef = useRef<SheetRef>(null);

  const { t } = useTranslation();

  return (
    <BottomSheet
      isOpen={open}
      onClose={onClose}
      ref={bottomSheetRef}
      snapPoints={variant === 'municipality' ? [1, 0.23, 0] : [1, 1, 0]}
      initialSnap={1}
    >
      {variant === 'advanced' && (
        <StyledContent overflowY="auto" variant="advanced">
          <Text>
            <SafeMarkdown text={t('modal.modal.municipality.advanced_search.title')} />
          </Text>

          <SearchMunicipalityForm onCloseBottomSheet={onClose} />
        </StyledContent>
      )}

      {variant === 'municipality' && (
        <StyledContent overflowY="auto" variant="municipality">
          <Text variant="h6">
            <SafeMarkdown text={t('modal.modal.municipality.search.title')} />
          </Text>

          <MunicipalityAutocomplete
            name="search-municipality"
            placeholder={t('placeholder.placeholder.search.municipality')}
            onChange={(_, value) => {
              if (value) {
                onMunicipalityChange?.(value);
                onClose();
              } else {
                onMunicipalityChange?.(null);
              }
            }}
            margin="none"
            fullWidth
          />
        </StyledContent>
      )}
    </BottomSheet>
  );
};
